import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import './TabSelectionButtons.scss';

const TabSelectionButtons = ({ selectedTab, tabs }) => {
    const navigate = useNavigate();

    const handleTabChange = (tabId) => {
        if (tabId === selectedTab) {
            console.log("Tab already selected, no navigation needed."); 
            return;
        }

        const params = new URLSearchParams(window.location.search); 
        params.set('tab', tabId); 

        navigate({ search: params.toString() }, { replace: true }); 
        // ✨ Use 'replace' option to avoid adding a new history entry
    };

    return (
        <Box className="tab-selection-button-container">
            {tabs.map((tabItem) => (
                <Button
                    key={tabItem.tab}
                    className={`tab-selection-button ${selectedTab === tabItem.tab ? 'active' : ''}`}
                    onClick={() => handleTabChange(tabItem.tab)}
                >
                    {tabItem.displayName}
                </Button>
            ))}
        </Box>
    );
};

export default TabSelectionButtons;
